import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "../pages/Header";
import Blog from "../pages/Blog";
import OurClient from "../pages/OurCients";
import WhyChoose from "../pages/WhyChoose";
import Whatwedo from "../pages/Whatwedo";
import Industries from "../pages/Industries";
import GridDesign from "../pages/GridDesign";
import LayoutDesign from "../pages/LayoutDesign";
import HomeServices from "../pages/HomeServices";
import BannerSlider from "../pages/BannerSlider";
import HomeBlogs from "../pages/HomeBlogs";
import Enquiry from "../pages/Enquiry";
import Faq from "../pages/faq";
import Tool from "../pages/Tool";
import BannerPages from "../pages/BannerPages";

const MainPage = () => {

  return (
    <div className="background-container bg-[#FFFCF8]">
        <Header/>
        <Header />
        {/* <BannerSlider/> */}
        <BannerPages/>
        <Whatwedo/>
        <GridDesign/>
        <LayoutDesign/>
        <WhyChoose/>
        <OurClient/>
        <HomeServices/>
        <Tool/>
        <Industries/>
        <Enquiry/>
        <Faq/>
        <HomeBlogs/>
    </div>
  );
};

export default MainPage;
